/* Sharrow Reports scripts (converted from Squarespace). */
(function () {
  /* Keep this at /on-water-experiences if you changed only the displayed name.
     Change it only if the Squarespace blog collection URL itself changed. */
  const BLOG_SLUG = "/on-water-experiences";
  const PAGE_SIZE = 24;
  const FILTER_LABELS = {
    all: "All Reports",
    speed: "Speed",
    fuel: "Fuel Economy",
    acceleration: "Acceleration",
    control: "Control"
  };

  const CATEGORY_TERMS = {
    speed: [
      "speed", "speeds", "faster", "fastest", "mph", "knot", "knots", "top end", "top-end",
      "midrange", "mid-range", "wot", "wide open throttle", "velocity", "higher rpm"
    ],
    fuel: [
      "fuel", "fuel economy", "fuel efficiency", "efficient", "efficiency", "mpg", "gph",
      "fuel burn", "burn rate", "consumption", "range", "gallon", "gallons", "miles per gallon"
    ],
    acceleration: [
      "acceleration", "accelerate", "accelerates", "hole shot", "holeshot", "time to plane",
      "on plane", "planing", "planes", "throttle response", "lower rpm", "rpm lower", "quickness"
    ],
    control: [
      "control", "handling", "docking", "dock", "maneuver", "maneuvering", "reverse", "grip",
      "bite", "tracking", "steering", "turn", "turning", "ventilation", "cavitation", "rough water",
      "smooth", "smoother", "vibration", "noise", "bow control", "low-speed", "low speed"
    ]
  };

  let allPosts = [];
  let filteredPosts = [];
  let visibleCount = PAGE_SIZE;
  let activeFilter = "all";
  let currentReport = null;
  let lastFocusedElement = null;
  let imageBaseWidth = 0;
  let imageBaseHeight = 0;
  let imageZoom = 1;

  const feed = document.getElementById("sharrowPerformanceFeed");
  const grid = document.getElementById("sxGrid");
  const status = document.getElementById("sxStatus");
  const count = document.getElementById("sxCount");
  const search = document.getElementById("sxSearch");
  const loadMore = document.getElementById("sxLoadMore");
  const filterButtons = Array.prototype.slice.call(document.querySelectorAll(".sx-filter"));

  const overlay = document.getElementById("sxOverlay");
  const panel = overlay.querySelector(".sx-panel");
  const panelContent = document.getElementById("sxPanelContent");
  const closeBtn = document.getElementById("sxClose");
  const overlayBg = overlay.querySelector(".sx-overlay-bg");
  const shareBtn = document.getElementById("sxShareBtn");
  const shareLabel = shareBtn.querySelector(".sx-share-label");

  const imageViewer = document.getElementById("sxImageViewer");
  const imageStage = document.getElementById("sxImageStage");
  const imageCanvas = document.getElementById("sxImageCanvas");
  const zoomImage = document.getElementById("sxZoomImage");
  const imageTitle = document.getElementById("sxImageTitle");
  const zoomInBtn = document.getElementById("sxZoomIn");
  const zoomOutBtn = document.getElementById("sxZoomOut");
  const zoomResetBtn = document.getElementById("sxZoomReset");
  const imageCloseBtn = document.getElementById("sxImageClose");

  /* Moving these directly under body escapes Squarespace section stacking contexts. */
  document.body.appendChild(overlay);
  document.body.appendChild(imageViewer);

  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
  }

  function esc(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatDate(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }

  function getImage(item) {
    return item.assetUrl || item.thumbnailUrl || item.imageUrl || item.featuredImageUrl ||
      (item.asset && item.asset.url) || (item.image && item.image.url) || "";
  }

  function getTags(item) {
    const categories = Array.isArray(item.categories) ? item.categories : [];
    const tags = Array.isArray(item.tags) ? item.tags : [];
    return Array.from(new Set(categories.concat(tags).map(function (tag) {
      return typeof tag === "string" ? tag : tag && tag.name;
    }).filter(Boolean)));
  }

  function getExcerpt(item) {
    return stripHtml(
      item.excerpt || item.description || item.seoDescription || item.summary || item.customExcerpt || ""
    ).slice(0, 220);
  }

  function countOccurrences(text, phrase) {
    if (!text || !phrase) return 0;
    let countValue = 0;
    let position = 0;
    while ((position = text.indexOf(phrase, position)) !== -1) {
      countValue += 1;
      position += phrase.length;
    }
    return countValue;
  }

  function scoreCategories(title, excerpt, tags, plain) {
    const sources = [
      { text: String(title || "").toLowerCase(), weight: 7 },
      { text: String(excerpt || "").toLowerCase(), weight: 4 },
      { text: String(tags || "").toLowerCase(), weight: 6 },
      { text: String(plain || "").slice(0, 1800).toLowerCase(), weight: 1 }
    ];

    const scores = {};
    Object.keys(CATEGORY_TERMS).forEach(function (category) {
      scores[category] = 0;
      sources.forEach(function (source) {
        CATEGORY_TERMS[category].forEach(function (term) {
          scores[category] += countOccurrences(source.text, term) * source.weight;
        });
      });
    });
    return scores;
  }

  function chooseCategories(scores) {
    const ranked = Object.keys(scores).map(function (key) {
      return { key: key, score: scores[key] };
    }).sort(function (a, b) { return b.score - a.score; });

    const highest = ranked.length ? ranked[0].score : 0;
    if (highest <= 0) return [];

    return ranked.filter(function (entry, index) {
      return entry.score >= 6 && (index === 0 || entry.score >= highest * 0.72);
    }).slice(0, 3).map(function (entry) { return entry.key; });
  }

  function normalize(item) {
    const body = item.body || item.fullContent || "";
    const plain = stripHtml(body);
    const tags = getTags(item);
    const excerpt = getExcerpt(item);
    const categoryScores = scoreCategories(item.title, excerpt, tags.join(" "), plain);

    return {
      id: item.id || item.urlId || item.fullUrl || item.title || Math.random().toString(36).slice(2),
      title: item.title || "Untitled Performance Report",
      date: item.publishOn || item.addedOn || item.updatedOn || item.createdOn || "",
      image: getImage(item),
      body: body,
      plain: plain,
      excerpt: excerpt,
      tags: tags,
      categories: chooseCategories(categoryScores),
      url: item.fullUrl || item.sourceUrl || item.url || "",
      searchText: [item.title, excerpt, plain, tags.join(" ")].join(" ").toLowerCase()
    };
  }

  async function fetchJson(url) {
    const el = document.getElementById("sharrow-reports-data");
    return el ? JSON.parse(el.textContent) : { items: [] };
  }

  async function fetchAllPosts() {
    const items = [];
    const seen = {};
    let nextUrl = BLOG_SLUG + "?format=json";
    let safety = 0;

    status.style.display = "block";
    status.textContent = "Loading performance reports...";

    while (nextUrl && safety < 30) {
      safety += 1;
      const data = await fetchJson(nextUrl);
      const batch = Array.isArray(data.items) ? data.items : [];

      batch.forEach(function (item) {
        const key = item.id || item.urlId || item.fullUrl || item.title;
        if (key && !seen[key]) {
          seen[key] = true;
          items.push(item);
        }
      });

      nextUrl =
        (data.pagination && (data.pagination.nextPageUrl || data.pagination.nextPage)) ||
        data.nextPageUrl ||
        (data.collection && data.collection.nextPageUrl) ||
        null;

      if (nextUrl && typeof nextUrl === "string" && nextUrl.indexOf("format=json") === -1) {
        nextUrl += (nextUrl.indexOf("?") > -1 ? "&" : "?") + "format=json";
      }
      if (typeof nextUrl !== "string") nextUrl = null;
    }

    allPosts = items.map(normalize).sort(function (a, b) {
      return new Date(b.date) - new Date(a.date);
    });

    allPosts.forEach(function (post, index) { post.sxIndex = index; });
    applyFilters(true);
  }

  function postMatchesSearch(post, query) {
    return !query || post.searchText.indexOf(query) !== -1;
  }

  function postMatchesCategory(post, category) {
    return category === "all" || post.categories.indexOf(category) !== -1;
  }

  function updateFilterButtons(query) {
    filterButtons.forEach(function (button) {
      const filter = button.getAttribute("data-filter") || "all";
      const filterCount = allPosts.filter(function (post) {
        return postMatchesSearch(post, query) && postMatchesCategory(post, filter);
      }).length;
      const number = button.querySelector("[data-filter-count]");
      if (number) number.textContent = filterCount;
      const selected = filter === activeFilter;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-pressed", selected ? "true" : "false");
    });
  }

  function applyFilters(resetVisible) {
    const query = (search.value || "").toLowerCase().trim();

    filteredPosts = allPosts.filter(function (post) {
      return postMatchesSearch(post, query) && postMatchesCategory(post, activeFilter);
    });

    if (resetVisible !== false) visibleCount = PAGE_SIZE;
    updateFilterButtons(query);
    render();
  }

  function currentResultLabel() {
    if (activeFilter === "all") return "performance report";
    return FILTER_LABELS[activeFilter].toLowerCase() + " report";
  }

  function render() {
    grid.innerHTML = "";

    if (!allPosts.length) {
      status.style.display = "block";
      status.innerHTML = "No reports yet. Add articles to the Performance Reports blog in Shopify (Content → Blog posts).";
      count.textContent = "0 reports";
      loadMore.style.display = "none";
      return;
    }

    if (!filteredPosts.length) {
      status.style.display = "block";
      status.textContent = "No matching " + currentResultLabel() + "s found.";
      count.textContent = "0 " + currentResultLabel() + "s";
      loadMore.style.display = "none";
      return;
    }

    status.style.display = "none";

    filteredPosts.slice(0, visibleCount).forEach(function (post, shownIndex) {
      const card = document.createElement("article");
      card.className = "sx-card" + (shownIndex === 0 ? " sx-card-featured" : "");

      const categoryTags = post.categories.map(function (category) {
        return FILTER_LABELS[category];
      }).filter(Boolean);
      const displayedTags = Array.from(new Set(categoryTags.concat(post.tags))).slice(0, 4);

      card.innerHTML = `
        <div class="sx-card-media">
          ${post.image
            ? `<img class="sx-img" loading="lazy" src="${esc(post.image)}" alt="${esc(post.title)}">`
            : `<div class="sx-img" role="img" aria-label="${esc(post.title)}"></div>`}
          <span class="sx-media-label">Performance Report</span>
        </div>
        <div class="sx-body">
          <div class="sx-date">${esc(formatDate(post.date))}</div>
          <h2 class="sx-title">${esc(post.title)}</h2>
          ${post.excerpt ? `<p class="sx-excerpt">${esc(post.excerpt)}${post.excerpt.length >= 220 ? "..." : ""}</p>` : ""}
          ${displayedTags.length ? `<div class="sx-tags">${displayedTags.map(function (tag) {
            return `<span class="sx-tag">${esc(tag)}</span>`;
          }).join("")}</div>` : ""}
          <div class="sx-card-actions">
            <button class="sx-open-report" type="button" data-post-index="${post.sxIndex}">Open Performance Report</button>
          </div>
        </div>`;

      grid.appendChild(card);
    });

    const noun = currentResultLabel();
    count.textContent = filteredPosts.length + " " + noun + (filteredPosts.length === 1 ? "" : "s");
    loadMore.style.display = filteredPosts.length > visibleCount ? "inline-flex" : "none";
  }

  function getShareUrl(post) {
    if (!post || !post.url) return window.location.href;
    try { return new URL(post.url, window.location.origin).href; }
    catch (error) { return window.location.href; }
  }

  function normalizeImageUrl(value, width) {
    let source = String(value || "").trim().replace(/&amp;/g, "&");
    if (!source || /^data:image\/(gif|svg)/i.test(source)) return "";
    source = source.replace(/\{width\}/g, String(width));
    source = source.replace(/([?&])format=\d+w/i, "$1format=" + width + "w");
    return source;
  }

  function largestSrcsetValue(value) {
    if (!value) return "";
    const candidates = String(value).split(",").map(function (part) {
      const pieces = part.trim().split(/\s+/);
      const size = pieces.length > 1 ? parseInt(pieces[pieces.length - 1], 10) || 0 : 0;
      return { url: pieces[0] || "", size: size };
    }).filter(function (candidate) { return candidate.url; });
    candidates.sort(function (a, b) { return b.size - a.size; });
    return candidates.length ? candidates[0].url : "";
  }

  function bestImageSource(img, width) {
    const pictureSource = img.closest("picture") && img.closest("picture").querySelector("source");
    const candidates = [
      img.getAttribute("data-src"),
      img.getAttribute("data-image"),
      img.getAttribute("data-image-url"),
      img.getAttribute("data-original"),
      img.getAttribute("data-lazy-src"),
      largestSrcsetValue(img.getAttribute("data-srcset")),
      largestSrcsetValue(img.getAttribute("srcset")),
      pictureSource ? largestSrcsetValue(pictureSource.getAttribute("srcset")) : "",
      img.currentSrc,
      img.getAttribute("src")
    ];

    for (let index = 0; index < candidates.length; index += 1) {
      const normalized = normalizeImageUrl(candidates[index], width || 2500);
      if (normalized) return normalized;
    }
    return "";
  }

  function compactMediaSource(value) {
    const source = String(value || "").trim();
    if (!source || /^data:/i.test(source)) return "";
    return source.slice(-320);
  }

  function normalizeMediaText(values) {
    return values.filter(Boolean).join(" ").toLowerCase().replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  }

  function mediaAttributeText(img) {
    return normalizeMediaText([
      img.getAttribute("alt"),
      img.getAttribute("title"),
      img.getAttribute("data-description"),
      img.getAttribute("data-caption"),
      img.getAttribute("data-image-title"),
      compactMediaSource(img.getAttribute("data-image")),
      compactMediaSource(img.getAttribute("data-src")),
      compactMediaSource(img.getAttribute("src")),
      img.className
    ]);
  }

  function mediaContextText(img) {
    const frame = img.closest("figure, .sqs-block-image, .image-block-outer-wrapper, .image-block");
    const caption = frame && frame.querySelector("figcaption, .image-caption, .sqs-image-caption, [class*='caption']");
    const previous = frame && frame.previousElementSibling;

    return normalizeMediaText([
      mediaAttributeText(img),
      frame && frame.className,
      caption && caption.textContent,
      previous && previous.textContent
    ]);
  }

  function inferMediaKind(img) {
    const explicit = String(
      img.getAttribute("data-media-type") ||
      img.getAttribute("data-sx-media-kind") ||
      ""
    ).toLowerCase();

    if (/^(graph|chart|plot)$/.test(explicit)) return "graph";
    if (/^(image|photo|photograph)$/.test(explicit)) return "image";

    const attributes = mediaAttributeText(img);
    const context = mediaContextText(img);
    const explicitGraphTerms = /\b(graph|chart|plot|scatterplot|scatter plot|bar chart|line chart|data visualization|performance curve|fuel curve|power curve)\b/;
    const explicitPhotoTerms = /\b(photo|photograph|boat underway|boat on the water|on water image|customer image|customer photo|engine photo|propeller photo|at the dock|at dock|marina)\b/;

    if (explicitGraphTerms.test(attributes)) return "graph";
    if (explicitPhotoTerms.test(attributes)) return "image";
    if (explicitGraphTerms.test(context)) return "graph";
    if (explicitPhotoTerms.test(context)) return "image";

    const metricTerms = [
      /\brpm\b/,
      /\bmph\b/,
      /\bmpg\b/,
      /\bgph\b/,
      /\bknots?\b/,
      /fuel economy/,
      /fuel burn/,
      /speed/,
      /acceleration/,
      /efficiency/,
      /advance rate/,
      /\bslip\b/,
      /time to plane/,
      /seconds?/
    ];
    const metricCount = metricTerms.reduce(function (total, pattern) {
      return total + (pattern.test(context) ? 1 : 0);
    }, 0);
    const comparisonLanguage = /\b(vs\.?|versus|compared|comparison|baseline|original|standard|sharrow|test data|measured results?)\b/;

    if (metricCount >= 2 && comparisonLanguage.test(context)) return "graph";
    return "";
  }

  function setMediaKind(img, index, kind) {
    const mediaKind = kind === "graph" ? "graph" : "image";
    const noun = mediaKind === "graph" ? "Graph" : "Image";
    const alt = String(img.getAttribute("alt") || "").trim();
    const label = "Enlarge " + noun;

    img.setAttribute("data-sx-media-kind", mediaKind);
    img.setAttribute("aria-label", alt ? label + ": " + alt : label + " " + (index + 1));
    img.setAttribute("title", label);

    const frame = img.closest("figure, .sqs-block-image, .image-block-outer-wrapper, .image-block") || img.parentElement;
    if (!frame) return;

    const button = frame.querySelector('.sx-enlarge-graph[data-sx-zoom-index="' + index + '"]');
    if (!button) return;

    button.setAttribute("data-sx-media-kind", mediaKind);
    button.setAttribute("aria-label", alt ? label + ": " + alt : label + " " + (index + 1));
    if (button.textContent !== label) button.textContent = label;
  }

  function visuallyProbeMediaKind(img, index) {
    if (img.getAttribute("data-sx-visual-probe") === "done") return;
    img.setAttribute("data-sx-visual-probe", "done");

    const source = bestImageSource(img, 700);
    if (!source) return;

    const probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.decoding = "async";

    probe.onload = function () {
      try {
        const maxDimension = 72;
        const scale = Math.min(1, maxDimension / Math.max(probe.naturalWidth || 1, probe.naturalHeight || 1));
        const width = Math.max(24, Math.round((probe.naturalWidth || maxDimension) * scale));
        const height = Math.max(24, Math.round((probe.naturalHeight || maxDimension) * scale));
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext("2d", { willReadFrequently: true });
        if (!context) return;
        context.drawImage(probe, 0, 0, width, height);
        const pixels = context.getImageData(0, 0, width, height).data;

        let total = 0;
        let paleNeutral = 0;
        let lowSaturation = 0;
        let colorful = 0;
        const buckets = new Set();

        for (let offset = 0; offset < pixels.length; offset += 4) {
          if (pixels[offset + 3] < 180) continue;
          const red = pixels[offset];
          const green = pixels[offset + 1];
          const blue = pixels[offset + 2];
          const maximum = Math.max(red, green, blue);
          const minimum = Math.min(red, green, blue);
          const spread = maximum - minimum;
          const luminance = (red * .2126 + green * .7152 + blue * .0722) / 255;

          total += 1;
          if (luminance > .88 && spread < 24) paleNeutral += 1;
          if (spread < 30) lowSaturation += 1;
          if (spread > 62) colorful += 1;
          buckets.add(((red >> 4) << 8) | ((green >> 4) << 4) | (blue >> 4));
        }

        if (!total) return;
        const paleRatio = paleNeutral / total;
        const neutralRatio = lowSaturation / total;
        const colorfulRatio = colorful / total;
        const paletteRatio = buckets.size / total;
        const resemblesGraph =
          (paleRatio > .50 && neutralRatio > .66 && colorfulRatio < .24) ||
          (paleRatio > .35 && neutralRatio > .77 && colorfulRatio < .16 && paletteRatio < .20);

        if (resemblesGraph) setMediaKind(img, index, "graph");
      } catch (error) {
        /* Cross-origin images may block pixel inspection. Text-based detection still applies. */
      }
    };

    probe.src = source;
  }

  function prepareReportImages() {
    const images = Array.prototype.slice.call(panelContent.querySelectorAll(".sx-panel-body img"));

    images.forEach(function (img, index) {
      const displaySource = bestImageSource(img, 1600);
      const currentSource = img.getAttribute("src") || "";
      if (displaySource && (!currentSource || /^data:image\/(gif|svg)/i.test(currentSource))) {
        img.setAttribute("src", displaySource);
      }

      img.removeAttribute("width");
      img.removeAttribute("height");
      img.setAttribute("data-sx-zoom-index", String(index));
      img.setAttribute("tabindex", "0");
      img.setAttribute("role", "button");
      img.setAttribute("loading", "eager");
      img.style.setProperty("pointer-events", "auto", "important");

      let frame = img.closest("figure, .sqs-block-image, .image-block-outer-wrapper, .image-block");
      if (!frame) frame = img.parentElement;
      if (!frame) return;

      frame.classList.add("sx-zoom-frame");
      let button = frame.querySelector('.sx-enlarge-graph[data-sx-zoom-index="' + index + '"]');
      if (!button) {
        button = document.createElement("button");
        button.type = "button";
        button.className = "sx-enlarge-graph";
        button.setAttribute("data-sx-zoom-index", String(index));
        frame.appendChild(button);
      }

      const inferredKind = inferMediaKind(img);
      setMediaKind(img, index, inferredKind || "image");
      if (!inferredKind) visuallyProbeMediaKind(img, index);
    });
  }

  function openOverlay(post) {
    if (!post) return;

    currentReport = post;
    lastFocusedElement = document.activeElement;
    panelContent.innerHTML = `
      <div class="sx-report-eyebrow">SHARROW™ PERFORMANCE REPORT${post.date ? " • " + esc(formatDate(post.date)) : ""}</div>
      <h2 class="sx-panel-title">${esc(post.title)}</h2>
      ${post.excerpt ? `<div class="sx-report-lead">${esc(post.excerpt)}</div>` : ""}
      <div class="sx-panel-body">${post.body}</div>
      <div class="sx-actions sx-report-actions">
        <a class="sx-btn sx-btn-primary" href="tel:+13136313494">Call Now</a>
        <a class="sx-btn sx-btn-glass" href="${(window.SHARROW_LINKS||{}).consultation_url}">Book a Consultation</a>
      </div>`;

    prepareReportImages();
    window.requestAnimationFrame(prepareReportImages);
    window.setTimeout(prepareReportImages, 350);

    panel.scrollTop = 0;
    overlay.classList.add("open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("sx-report-open");
    window.setTimeout(function () { shareBtn.focus({ preventScroll: true }); }, 50);
  }

  function imageViewerIsOpen() {
    return Boolean(imageViewer.open || imageViewer.hasAttribute("open"));
  }

  function closeOverlay() {
    if (imageViewerIsOpen()) {
      closeImageViewer();
      return;
    }

    overlay.classList.remove("open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("sx-report-open");
    currentReport = null;

    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      lastFocusedElement.focus({ preventScroll: true });
    }
  }

  async function shareCurrentReport() {
    if (!currentReport) return;
    const url = getShareUrl(currentReport);
    const title = currentReport.title || "Sharrow Performance Report";

    if (navigator.share) {
      try {
        await navigator.share({ title: title, text: title, url: url });
        return;
      } catch (error) {
        if (error && error.name === "AbortError") return;
      }
    }

    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error("Clipboard unavailable");
      await navigator.clipboard.writeText(url);
      shareLabel.textContent = "Link Copied";
      shareBtn.classList.add("copied");
      window.setTimeout(function () {
        shareLabel.textContent = "Share Report";
        shareBtn.classList.remove("copied");
      }, 1800);
    } catch (error) {
      window.prompt("Copy this report link:", url);
    }
  }

  function updateHeaderOffset() {
    let headerHeight = 0;
    document.querySelectorAll("header, .Header, .header, [data-test='header'], .header-announcement-bar-wrapper").forEach(function (element) {
      if (element.closest("#sxOverlay") || element.closest("#sxImageViewer")) return;
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      const pinned = style.position === "fixed" || style.position === "sticky";
      const visible = rect.height > 0 && style.display !== "none" && style.visibility !== "hidden";
      if (pinned && visible && rect.top <= 2) headerHeight = Math.max(headerHeight, Math.min(rect.height, 180));
    });
    feed.style.setProperty("--sx-header-offset", Math.max(12, Math.round(headerHeight + 12)) + "px");
  }

  function applyImageZoom(centerImage) {
    zoomImage.style.width = Math.max(1, Math.round(imageBaseWidth * imageZoom)) + "px";
    zoomImage.style.height = Math.max(1, Math.round(imageBaseHeight * imageZoom)) + "px";
    zoomResetBtn.textContent = Math.round(imageZoom * 100) + "%";
    zoomImage.style.cursor = imageZoom > 1 ? "zoom-out" : "zoom-in";

    if (centerImage) {
      window.requestAnimationFrame(function () {
        imageStage.scrollLeft = Math.max(0, (imageCanvas.scrollWidth - imageStage.clientWidth) / 2);
        imageStage.scrollTop = Math.max(0, (imageCanvas.scrollHeight - imageStage.clientHeight) / 2);
      });
    }
  }

  function fitViewerImage() {
    if (!imageViewerIsOpen()) return;
    const naturalWidth = zoomImage.naturalWidth || 1200;
    const naturalHeight = zoomImage.naturalHeight || 800;
    const availableWidth = Math.max(260, imageStage.clientWidth - 56);
    const availableHeight = Math.max(180, imageStage.clientHeight - 56);
    const fitScale = Math.min(1, availableWidth / naturalWidth, availableHeight / naturalHeight);

    imageBaseWidth = naturalWidth * fitScale;
    imageBaseHeight = naturalHeight * fitScale;
    imageZoom = 1;
    applyImageZoom(true);
  }

  function setImageZoom(nextZoom) {
    imageZoom = Math.min(5, Math.max(0.5, Math.round(nextZoom * 100) / 100));
    applyImageZoom(true);
  }

  function showImageDialog() {
    if (typeof imageViewer.showModal === "function") {
      if (!imageViewer.open) imageViewer.showModal();
    } else {
      imageViewer.setAttribute("open", "");
    }
  }

  function openImageViewer(img) {
    const source = bestImageSource(img, 2500);
    if (!source) return;

    const mediaKind = img.getAttribute("data-sx-media-kind") === "graph" ? "graph" : "image";
    const mediaNoun = mediaKind === "graph" ? "graph" : "image";
    const alt = String(img.getAttribute("alt") || "").trim();
    const fallbackTitle = mediaKind === "graph" ? "Performance graph" : "Report image";

    imageTitle.textContent = alt || fallbackTitle;
    zoomImage.alt = alt ? "Enlarged " + alt : "Enlarged " + mediaNoun;
    imageViewer.setAttribute("aria-label", "Enlarged report " + mediaNoun);
    imageCloseBtn.setAttribute("aria-label", "Close enlarged " + mediaNoun);
    zoomImage.removeAttribute("style");
    imageBaseWidth = 0;
    imageBaseHeight = 0;
    imageZoom = 1;

    showImageDialog();
    document.body.classList.add("sx-image-open");
    zoomImage.src = source;

    window.requestAnimationFrame(function () {
      if (zoomImage.complete && zoomImage.naturalWidth) fitViewerImage();
    });
    window.setTimeout(function () {
      if (zoomImage.naturalWidth) fitViewerImage();
      imageCloseBtn.focus({ preventScroll: true });
    }, 80);
  }

  function closeImageViewer() {
    if (typeof imageViewer.close === "function" && imageViewer.open) {
      imageViewer.close();
    } else {
      imageViewer.removeAttribute("open");
    }
    document.body.classList.remove("sx-image-open");
    zoomImage.removeAttribute("src");
    zoomImage.removeAttribute("style");
    imageZoom = 1;
  }

  function findZoomImage(target) {
    const button = target.closest && target.closest(".sx-enlarge-graph");
    if (button) {
      const index = button.getAttribute("data-sx-zoom-index");
      return panelContent.querySelector('.sx-panel-body img[data-sx-zoom-index="' + index + '"]');
    }
    return target.closest && target.closest(".sx-panel-body img[data-sx-zoom-index]");
  }

  grid.addEventListener("click", function (event) {
    const button = event.target.closest(".sx-open-report");
    if (button) openOverlay(allPosts[Number(button.getAttribute("data-post-index"))]);
  });

  /* Capture phase guarantees the zoom opens even when a Squarespace image is wrapped in a link. */
  panelContent.addEventListener("click", function (event) {
    const image = findZoomImage(event.target);
    if (!image) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openImageViewer(image);
  }, true);

  panelContent.addEventListener("keydown", function (event) {
    const image = event.target.closest && event.target.closest(".sx-panel-body img[data-sx-zoom-index]");
    if (image && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      openImageViewer(image);
    }
  }, true);

  filterButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      activeFilter = button.getAttribute("data-filter") || "all";
      applyFilters(true);
    });
  });

  shareBtn.addEventListener("click", shareCurrentReport);
  search.addEventListener("input", function () { applyFilters(true); });
  loadMore.addEventListener("click", function () {
    visibleCount += PAGE_SIZE;
    applyFilters(false);
  });
  closeBtn.addEventListener("click", closeOverlay);
  overlayBg.addEventListener("click", closeOverlay);

  zoomImage.addEventListener("load", fitViewerImage);
  zoomInBtn.addEventListener("click", function () { setImageZoom(imageZoom + 0.25); });
  zoomOutBtn.addEventListener("click", function () { setImageZoom(imageZoom - 0.25); });
  zoomResetBtn.addEventListener("click", function () { setImageZoom(1); });
  imageCloseBtn.addEventListener("click", closeImageViewer);
  zoomImage.addEventListener("click", function () { setImageZoom(imageZoom > 1 ? 1 : 2); });

  imageViewer.addEventListener("cancel", function (event) {
    event.preventDefault();
    closeImageViewer();
  });

  document.addEventListener("keydown", function (event) {
    if (imageViewerIsOpen()) {
      if (event.key === "+" || event.key === "=") setImageZoom(imageZoom + 0.25);
      if (event.key === "-") setImageZoom(imageZoom - 0.25);
      if (event.key === "0") setImageZoom(1);
      return;
    }
    if (overlay.classList.contains("open") && event.key === "Escape") closeOverlay();
  });

  window.addEventListener("resize", function () {
    updateHeaderOffset();
    if (imageViewerIsOpen() && zoomImage.naturalWidth) fitViewerImage();
  });

  const reportImageObserver = new MutationObserver(function () {
    if (overlay.classList.contains("open")) prepareReportImages();
  });
  reportImageObserver.observe(panelContent, { childList: true, subtree: true });

  updateHeaderOffset();
  window.setTimeout(updateHeaderOffset, 600);
  window.setTimeout(updateHeaderOffset, 1800);

  console.info("Sharrow Performance Reports v2.4 loaded");

  fetchAllPosts().catch(function (error) {
    console.error(error);
    status.style.display = "block";
    status.innerHTML = "The performance reports could not load.";
    count.textContent = "Error loading reports";
  });
})();

(function () {
  "use strict";

  const params = new URLSearchParams(window.location.search);
  const requestedKey = String(params.get("report") || "")
    .replace(/^\/+|\/+$/g, "")
    .toLowerCase();

  if (!requestedKey) return;

  const reportSearchMap = {
    "2025/12/9/added-range-with-sharrow-xo-props-on-this-world-cat-40-cc-x-with-twin-yamaha-425-xtos": "World Cat 40 CC-X",
    "pursuit-s-328-with-sharrow-mx-propellers": "Pursuit S 328",
    "2025/4/13/better-hole-shot-smoother-handling-and-less-fuel-burn-on-axopar-28-cabin-with-mercury-300-hp": "Axopar 28 Cabin",
    "2022/12/20/boattest-captains-report-sharrow-mx-propeller-review-world-cat-325-dc-with-twin-yamaha-300-hp-motors": "World Cat 325 DC",
    "dramatic-noise-reduction-at-cruising-speeds": "Regal 38 SAV",
    "new-world-record": "NEW WORLD RECORD",
    "2025/12/29/superior-control-with-sharrow-propeller-on-a-stingray-231-dc-with-single-suzuki-200-hp": "Stingray 231 DC",
    "2025/11/19/sharrow-mx-propeller-delivers-mid-range-advantage-on-duckworth-pacific-pro-24-with-yamaha-300-hp": "Duckworth Pacific Pro 24",
    "sharrow-mx4-propeller": "Vexus DVX 20S"
  };

  function wordsFromKey(key) {
    return key
      .replace(/^\d{4}\/\d{1,2}\/\d{1,2}\//, "")
      .replace(/[-_/]+/g, " ")
      .replace(/\b(with|this|the|and|on|at|a|an|sharrow|propeller|propellers)\b/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  const searchPhrase = reportSearchMap[requestedKey] || wordsFromKey(requestedKey);
  const expected = normalize(searchPhrase);
  let opened = false;
  let searchApplied = false;
  let attempts = 0;

  function findAndOpenReport() {
    if (opened) return true;
    attempts += 1;

    const search = document.getElementById("sxSearch");
    const grid = document.getElementById("sxGrid");
    if (!search || !grid) return false;

    if (!searchApplied) {
      search.value = searchPhrase;
      search.dispatchEvent(new Event("input", { bubbles: true }));
      searchApplied = true;
      return false;
    }

    const cards = Array.from(grid.querySelectorAll(".sx-card"));
    if (!cards.length) return false;

    let match = cards.find(function (card) {
      const title = normalize(card.querySelector(".sx-title")?.textContent);
      return title.indexOf(expected) !== -1 || expected.indexOf(title) !== -1;
    });

    if (!match && cards.length === 1) match = cards[0];
    if (!match) return false;

    const openButton = match.querySelector(".sx-open-report");
    if (!openButton) return false;

    opened = true;
    openButton.click();
    return true;
  }

  const observer = new MutationObserver(function () {
    if (findAndOpenReport()) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  const timer = window.setInterval(function () {
    if (findAndOpenReport() || attempts > 80) {
      window.clearInterval(timer);
      observer.disconnect();
    }
  }, 250);

  function clearReportParameter() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has("report")) return;
    url.searchParams.delete("report");
    window.history.replaceState({}, "", url.pathname + url.search + url.hash);
  }

  function wireCloseButtons() {
    const close = document.getElementById("sxClose");
    const backdrop = document.querySelector("#sxOverlay .sx-overlay-bg");
    if (close && !close.dataset.deepLinkWired) {
      close.dataset.deepLinkWired = "true";
      close.addEventListener("click", clearReportParameter);
    }
    if (backdrop && !backdrop.dataset.deepLinkWired) {
      backdrop.dataset.deepLinkWired = "true";
      backdrop.addEventListener("click", clearReportParameter);
    }
  }

  wireCloseButtons();
  window.setTimeout(wireCloseButtons, 800);
  window.setTimeout(wireCloseButtons, 1800);
})();
